/* eslint-disable no-constant-condition */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import CustomAddActionCard from '../../../common/components/CustomAddActionCard/CustomAddActionCard';
import { Grid, Typography } from '@mui/material';
import emptyIcon from '../../../assets/images/empty_icon.svg';
import { fonts, themes } from '../../../common/themes/themes';
import Loader from '../../../common/Lottifiers/Loader/Loader';
import ApplyLetterModalController from '../../../common/Modals/LetterGeneration/ApplyLetterModal/ApplyLetterModalController';
import AppliedLetterTile from '../../../common/components/AppliedLetterTile/AppliedLetterTile';
import LetterViewModalController from '../../../common/Modals/LetterGeneration/LetterViewModal/LetterViewModalController';
import { useTranslate } from '../../../hooks';
import { useListLetters } from '../../../pages/letterGeneration/api';
import { LetterGenerationStatus } from '../../../common/Modals/LetterGeneration/constants';

import './styles.css'

const EmergencyContactPresenter: React.FC = () => {
  const [createLetterRequestModal, showCreateLetterRequestModal] =
    useState(false);
  const [selectedLetter, setSelectedLetter] = useState<string | null>(null);

  const { translate } = useTranslate();
  const { data: letters, isLoading: isLoadingLetters } = useListLetters({
    params: {
      statuses: [LetterGenerationStatus.REQUESTED.toLowerCase()],
    },
  });

  return (
    <>
      <CustomAddActionCard
        card_title={translate('Applied') || ''}
        height="62vh"
        onClick={() => showCreateLetterRequestModal(true)}
        card_subtitle={`${translate('Total')} : ${letters?.length || 0}`}
      >
        {isLoadingLetters ? (
          <Loader height={100} width={200} />
        ) : letters?.length > 0 ? (
          <div className="applied-list">
            {letters?.map((letter: any) => {
              return (
                <AppliedLetterTile
                  key={letter.id}
                  ticketName={letter.letterType?.title}
                  startDate={letter?.createdAt}
                  applicant={letter?.employeeName}
                  status={translate(letter.status)}
                  onClick={() => {
                    setSelectedLetter(letter.id);
                  }}
                  showViewBtn
                />
              );
            })}
          </div>
        ) : (
          <Grid container>
            <Grid
              item
              xs={12}
              style={{
                textAlign: 'center',
              }}
            >
              <img src={emptyIcon} />
            </Grid>
            <Grid
              item
              xs={12}
              style={{
                textAlign: 'center',
              }}
            >
              <Typography
                style={{
                  fontFamily: fonts.fontFamily,
                  fontSize: fonts.title,
                  color: themes.blackDefault,
                  fontWeight: 'bold',
                }}
              >
                {translate('Not Added')}
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              style={{
                textAlign: 'center',
              }}
            >
              <Typography
                style={{
                  fontFamily: fonts.fontFamily,
                  fontSize: fonts.subtitle,
                  color: themes.defaultIcon,
                }}
              >
                {translate('Currently you haven’t Applied Letter')}
              </Typography>
            </Grid>
          </Grid>
        )}
      </CustomAddActionCard>

      {/* Create Request Letter Modal */}
      {createLetterRequestModal && (
        <ApplyLetterModalController
          isModalOpen={createLetterRequestModal}
          closeModal={() => showCreateLetterRequestModal(false)}
        />
      )}

      {/* View Apply Letter Modal */}
      {selectedLetter && (
        <LetterViewModalController
          isModalOpen={selectedLetter ? true : false}
          id={selectedLetter}
          closeModal={() => setSelectedLetter(null)}
        />
      )}
    </>
  );
};

export default EmergencyContactPresenter;
